/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {dismissOnDestroyToken as ɵd,fireOnInitToken as ɵc,swalProviderToken as ɵb} from './lib/di';
export {SwalPortalComponent as ɵe} from './lib/swal-portal.component';
export {provideDefaultSwal as ɵa} from './lib/sweetalert2.module';